import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createStoreApi } from "../../services/store/create.store.api";

export const useCreateStoreApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (infoCreate: any) => createStoreApi(infoCreate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["all-store"],
      });
    },
  });
};
